// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3vm1A","inputWrap":"Table_inputWrap__27a0R","col":"Table_col__2US-E","bmiTooltip":"Table_bmiTooltip__3b-6Y"};